import { render } from "./region-delete.vue?vue&type=template&id=f581b59a"
import script from "./region-delete.vue?vue&type=script&lang=js"
export * from "./region-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__